<template>
  <div>
    <div class="footer">
      <div class="banxin">
        <!-- <div class="top">
                    <template v-for="(item,index) in advantage" @key="index">
                        <div :key="index">
                            <span v-if="item.iconFont" class="footIcon" :class="item.iconFont"></span>
                            <span>{{item.name}}</span>
                        </div>
                        <span :key="index" v-if="index !== advantage.length - 1"></span>
                    </template>
                </div> -->
        <div class="center">
          <div class="help-container">
            <div v-for="(item, index) in center.help" :key="index">
              <div>{{ item.title }}</div>
              <!-- <a
                v-for="item2 in item.content"
                :key="item2.name"
                :href="item2.url"
              >
                {{ item2.name }}
              </a> -->
              <router-link
                v-for="item2 in item.content"
                :key="item2.name"
                :to="{ path: '/helpCenter', query: { categoryId: item2.url } }"
              >
                {{ item2.name }}
              </router-link>
            </div>
          </div>
          <span class="line"></span>
          <div class="phone-container">
            <div>{{ center.phone.number }}</div>
            <div>{{ center.phone.title }}</div>
            <span>
              <!-- <img src="../../../static/image/call_me.png" alt=""> -->
              <i class="el-icon-phone"></i>
              联系客服
            </span>
          </div>
          <span class="line"></span>
          <div class="QR-container">
            <div v-for="(item, index) in center.QR_code" :key="index">
              <img :src="item.code" alt="" />
              <div>
                <img :src="item.icon" alt="" />
                <span>{{ item.text }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="bottom">
      <div class="bottom-content">
        <div class="go-another">
          <template v-for="(item, index) in bottom.content" @key="index">
            <a :href="item.url" :key="item.i">{{ item.name }}</a>
            <span
              :key="index"
              v-if="index !== bottom.content.length - 1"
            ></span>
          </template>
        </div>
        <div>{{ bottom.text }}</div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      advantage: [
        {
          name: "预约维修服务",
          icon: "../../../static/image/foot-advantage-01.png",
          iconFont: "icon-maintenance",
        },
        {
          name: "7天无理由退货",
          icon: "../../../static/image/foot-advantage-02.png",
          iconFont: "icon-Seven-days",
        },
        {
          name: "15天免费换货",
          icon: "../../../static/image/foot-advantage-03.png",
          iconFont: "icon-15-days",
        },
        {
          name: "满300元包邮",
          icon: "../../../static/image/foot-advantage-04.png",
          iconFont: "icon-Package-mail",
        },
        {
          name: "附近售后服务站",
          icon: "../../../static/image/foot-advantage-05.png",
          iconFont: "icon-positioning",
        },
      ],
      center: {
        help: [
          {
            title: "购物指南",
            content: [
              { name: "购物流程", url: "14" },
              { name: "交易规则", url: "13" },
              { name: "商品咨询", url: "16" },
            ],
          },
          // {
          //     title:'供应商服务',
          //     content:[
          //         // {name:'供应商加盟',url:'#'},
          //         {name:'商品管理',url:'#'},
          //         {name:'开设账户',url:'#'},
          //     ]
          // },
          {
            title: "订单问题",
            content: [
              { name: "提交订单", url: "17" },
              { name: "查询订单", url: "18" },
              { name: "订单确认", url: "23" },
            ],
          },
          {
            title: "支付问题",
            content: [
              { name: "在线支付", url: "26" },
              { name: "转账汇款", url: "27" },
              { name: "账期支付", url: "28" },
            ],
          },
        ],
        phone: {
          number: "400-082-3688",
          title: "全国统一服务热线",
        },
        QR_code: [
          // {
          //   code: "../../../static/image/QR-public.png",
          //   icon: "../../../static/image/iPhone-icon.png",
          //   text: "iphone",
          // },
          {
            code: "../../../static/image/Android-code.png",
            icon: "../../../static/image/Android-icon.png",
            text: "Android",
          },
        ],
      },
      bottom: {
        content: [
          { name: "关于我们", url: "#", i: "关于我们" },
          { name: "联系我们", url: "#", i: "联系我们" },
          { name: "合作品牌", url: "#", i: "合作品牌" },
          { name: "友情链接", url: "#", i: "友情链接" },
          { name: "法律声明", url: "#", i: "法律声明" },
          { name: "新闻动态", url: "#", i: "新闻动态" },
        ],
        text: "COPYRIGHT (©) 2021-2022保山数字产业发展有限责任公司 ALL RIGHTS RESERVED 滇ICP备2021004155号",
      },
    };
  },
};
</script>
<style lang = "scss" scoped>
.footer {
  width: 100%;
  /* height: 307px; */
  height: 240px;
  background-color: #ffffff;
  opacity: 0.82;
  color: #000000;
  overflow: hidden;

  .banxin {
    width: 90%;
    max-width: 1612px;
    height: 100%;
    margin: 0 auto;
    .top {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 39px 3% 37px 3%;
      border-bottom: 1px solid #e5e5e5;
      & > div {
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 20px;
        color: #666666;
      }
      & > span {
        display: inline-block;
        width: 1px;
        height: 40px;
        background-color: #e5e5e5;
      }
      .footIcon {
        font-size: 31px;
        margin-right: 6px;
      }
      /* img{
                display: inline-block;
                height: 32px;
            } */
    }
    .center {
      padding: 46px 3% 41px 3%;
      display: flex;
      align-items: center;
      .line {
        display: inline-block;
        width: 1px;
        height: 106px;
        background: #e5e5e5;
      }
      .help-container {
        width: 57%;
        display: flex;
        & > div {
          flex-grow: 1;
          div {
            font-size: 18px;
            color: #333333;
            margin-bottom: 16px;
            font-weight: bold;
          }
          a {
            font-size: 14px;
            color: #666666;
            display: block;
            margin-bottom: 7px;
          }
        }
      }
      .phone-container {
        width: 23%;
        text-align: center;
        & > div:first-child {
          font-size: 28px;
          color: #f77b0b;
          margin-bottom: 9px;
        }
        & > div:nth-child(2) {
          font-size: 14px;
          color: #666666;
        }
        & > span {
          cursor: pointer;
          margin: 14px auto 0 auto;
          display: flex;
          align-items: center;
          justify-content: center;
          width: 114px;
          height: 31px;
          border-radius: 2px;
          border: 1px solid #f77b0b;
          font-size: 14px;
          color: #f77b0b;
          i {
            color: #f77b0b;
            font-size: 18px;
            margin-right: 4px;
          }
        }
      }
      .QR-container {
        width: 20%;
        display: flex;
        justify-content: flex-end;
        align-items: center;
        & > div {
          margin-right: 20px;
          & > img {
            display: inline-block;
            height: 80px;
          }
          & > div {
            display: flex;
            justify-content: center;
            align-items: center;
            font-size: 12px;
            color: #666666;
            img {
              display: inline-block;
              height: 16px;
              margin-right: 4px;
            }
          }
        }
        & > div:last-child {
          margin: 0;
        }
      }
    }
  }
}
.bottom {
  height: 129px;
  /* background: #484848; */

  background: #232222;
  text-align: center;
  font-size: 12px;
  color: #444444;
  .bottom-content {
    width: 50%;
    margin: 0 auto;
    display: flex;
    height: 100%;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    & > div {
      font-size: 14px;
      color: #ffffff;
      opacity: 0.7;
      width: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .go-another {
      margin-bottom: 21px;
      opacity: 1;
      span {
        display: inline-block;
        height: 14px;
        width: 1px;
        background: #ffffff;
        opacity: 0.8;
        margin: 0 21px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/base_b2c/footer.vue